/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc */

	/**
	 * DMIS DLC
	 *
	 * @author Thomas Amsler
	 * @namespace Tc.Module
	 * @class DmisDlc
	 * @extends Tc.Module
	 */

	Tc.Module.DmisDlc = Tc.Module.extend({

		/**
		 * Initializes DmisDlc and attaches events
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {

			var mod = this,
				$ctx = mod.$ctx;
			
			mod.results = [];
			mod.allresults = [];
			mod.container = $('.dlc-container', $ctx);
			mod.resultsPerPage = parseInt(mod.container.data('results-per-page'));
			mod.end = mod.resultsPerPage;
			mod.button = $('button.more-results', $ctx);
			mod.tmplRow = doT.template($('.tmpl-dlc-row', $ctx).html());
			
			var hashs = (location.hash.substring(1)).split('&');
			if (hashs.length && hashs[0] != '') {
				for (var i=0; i<hashs.length; i++) {
					var parts = hashs[i].split('=');
					var select = $('select[name="dlc-' + parts[0] + '"]');
					select.find('option').filter(function(index) { return $(this).text() === parts[1]; }).prop('selected', true);
					select.change();
				}
			}
			mod.getResults(0);

			$('select', $ctx).on('change', function() {
				mod.displayData();
			});
			
			$ctx.find('.reset a').on('click', function () {
				var form = $(this).closest('form');
				
				form[0].reset();
				//alert("ok2" + form.find('select').trigger);
//				form.find('select').eq(0).trigger('change');
				
				form.find('select').eq(0).find('option').eq(0).attr('selected',true);
				form.find('select').eq(1).find('option').eq(0).attr('selected',true);
				form.find('select').eq(2).find('option').eq(0).attr('selected',true);
				form.find('select').eq(0).trigger('change')
				form.find('select').eq(1).trigger('change')
				form.find('select').eq(2).trigger('change')
				
			});

			callback();
		},
		
		doPaging: function(start) {
			var mod = this;
			if (mod.results.length > (start + mod.resultsPerPage)) {
				mod.end = start + mod.resultsPerPage;
				mod.button.off('click').click(function() {
					mod.doPaging(mod.end);
				}).removeClass('is-hidden');
			}
			else {
				mod.end = mod.results.length;
				mod.button.addClass('is-hidden');
			}
			mod.showResults();
		},
		
		showResults: function() {
			var mod = this;
			var rows = mod.container.find('.row');
			for (var i=0; i<mod.end; i++) {
				$(rows[i]).removeClass('is-hidden');
			}
		},
	
		filterResults: function()
		{
			var mod = this,
			$ctx = mod.$ctx;
			
			var yearFilter = $('select[name="dlc-year"]', $ctx).val();
			var areaFilter = $('select[name="dlc-area"]', $ctx).val();
			var topicFilter = $('select[name="dlc-topic"]', $ctx).val();

			mod.results=mod.allresults;
			
			mod.filterResultsByCriteria(yearFilter);
			mod.filterResultsByCriteria(areaFilter);
			mod.filterResultsByCriteria(topicFilter);
			mod.results.sort(mod.sortByDate);
		},
		
		filterResultsByCriteria: function(filterCriteria)
		{
			var mod = this,
			$ctx = mod.$ctx;
			
			if (filterCriteria!=undefined && filterCriteria.length>0)
			{
			var tmpResults = [];
			var splittedFilter=filterCriteria.split("/");
			var filterKey = splittedFilter[0];
			var filterVal = splittedFilter[1];
			
			for (var i=0; i<mod.results.length; i++) {
				if (mod.results[i].hasOwnProperty(filterKey) && mod.results[i][filterKey]==filterVal)
					{
					tmpResults.push(mod.results[i]);
					}
				}
			mod.results=tmpResults;
			}
			
			
		},
		
		sortByDate: function(a, b)
		{
			var aName = a['sortDate'];
			var bName = b['sortDate']; 
			if (aName==bName)
				{
				return a['title'].localeCompare(b['title']);
				}

			  return ((aName > bName) ? -1 : ((aName < bName) ? 1 : 0));	

		},
		
		displayData: function() {
			var mod = this,
			$ctx = mod.$ctx;			
			mod.container.empty();
			mod.button.addClass('is-hidden');
			mod.filterResults();
			if (mod.results.length > 0) {
				if (mod.end > mod.results.length) {
					mod.end = mod.results.length;
				}
				$('.dlc-no-results', $ctx).addClass('is-hidden');
				$('.dlc-results', $ctx).removeClass('is-hidden'); 
				for (var i=0; i<mod.results.length; i++) {
					mod.results[i].cls = 'row is-hidden';
					$(mod.tmplRow(mod.results[i])).appendTo(mod.container);
				}
				mod.doPaging(0);
			}
			else {
				$('.dlc-no-results', $ctx).removeClass('is-hidden');
				$('.dlc-results', $ctx).addClass('is-hidden');
			}
					
		},
		getResults: function() {
			var mod = this,
				$ctx = mod.$ctx;
			
			mod.container.empty();
			$('.scs-loadingRotator', $ctx).removeClass('is-hidden');
			$.ajax({
				url: mod.container.data('url'),
				dataType: 'json',
				type: 'GET',
				data: {
					},
				success: function (data) {
					$('.scs-loadingRotator', $ctx).addClass('is-hidden');
					mod.allresults = data.results || [];
					mod.filterResults();
					if (data.error) {
						$('.dlc-error', $ctx).removeClass('is-hidden');
					}
					else
						{
						mod.displayData();
						}
					
				},
				error: function (data) {
					mod.allresults = [];
					$('.scs-loadingRotator', $ctx).addClass('is-hidden');
					$('.dlc-error', $ctx).removeClass('is-hidden');
				}
			});
		}
	});
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.DmisDlc.js
// module id = 138
// module chunks = 0